import { Box, Container } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { usePageFooter } from '#/providers/page-layout-provider';

export function PageFooter() {
  const { footerRef } = usePageFooter();
  const [hasContent, setHasContent] = useState(false);

  useEffect(() => {
    const checkContent = () => {
      if (footerRef.current) {
        const hasChildren = footerRef.current.children.length > 0;
        setHasContent(hasChildren);
      } else {
        setHasContent(false);
      }
    };

    // Check after a microtask to ensure ref is attached and portal content may have rendered
    Promise.resolve().then(checkContent);

    // Set up MutationObserver to watch for changes
    const observer = new MutationObserver(checkContent);

    if (footerRef.current) {
      observer.observe(footerRef.current, {
        childList: true,
        subtree: true,
      });
    }

    return () => {
      observer.disconnect();
    };
  }, [footerRef]);

  return (
    <Box
      position="relative"
      zIndex={10}
      bg="var(--background-base-color)"
      shadow="none"
      borderTopWidth="var(--border-base-width)"
      borderColor="var(--border-base-color)"
      flexShrink={0}
      width="100%"
      display={hasContent ? 'block' : 'none'}
    >
      <Container maxW="7xl" px={4} py={3}>
        {/* Portal target for page footer content */}
        <Box ref={footerRef} width="100%" />
      </Container>
    </Box>
  );
}
